import React from "react";

export default function FavoritesPage({ specialists, onSelect, likes, toggleLike }) {
  const likedSpecialists = specialists.filter(s => likes.includes(s.id));

  return (
      <div style={{ display: "flex", flexDirection: "column", gap: "20px", alignItems: "center" }}>
      <h2 style={{ textAlign: "center" }}>Избранное</h2>

      {likedSpecialists.length === 0 && (
        <p style={{ textAlign: "center" }}>Пока пусто</p>
      )}

      {likedSpecialists.map((s) => (
          <div
              key={s.id}
              style={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  padding: "20px",
                  width: "280px",
                  boxShadow: "2px 2px 6px rgba(0,0,0,0.1)",
                  backgroundColor: "#fafafa",
                  textAlign: "center",
                  position: "relative"
              }}
          >
              <div
                  onClick={() => onSelect(s)}
                  style={{
                      padding: "12px",
                      marginBottom: "24px",
                      cursor: "pointer",
                      minHeight: "260px",
                      alignContent: "center"
                  }}
              >
                  { s.about }
              </div>

              <hr  style={{ width: "40%", marginBottom: "24px"}}/>

              <div
                  style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "start",
                      textAlign: "start"
                  }}
              >
                  <img
                      src={s.preview}
                      alt={s.firstname}
                      style={{
                          width: "64px",
                          height: "64px",
                          borderRadius: "50%",
                          objectFit: "cover"
                      }}
                  />

                  <div
                      onClick={() => onSelect(s)}
                      style={{ cursor: "pointer", fontSize: "small" }}
                  >
                      <h3 style={{ margin: 0 }}>{s.firstname}</h3>
                      <p style={{ margin: "5px 0 0 0" }}>Опыт: {s.workExperience}</p>
                      <p style={{ margin: "5px 0 0 0" }}>Прием: {s.adultIndividualPrice} руб.</p>

                  </div>

                  {/* Иконка лайка */}
                  <span
                      onClick={(e) => {
                          e.stopPropagation(); // чтобы не открывалась модалка
                          toggleLike(s.id);
                      }}
                      style={{
                          fontSize: "22px",
                          cursor: "pointer",
                          color: "red",
                          userSelect: "none"
                      }}
                  >
              ❤️
            </span>
              </div>
              <div style={{ display: "flex", alignItems: "center", marginTop: "12px" }}>
                  <a href={s.bookingUrl} target="_blank" style={{ width: "100%"}} className="button-secondary">Записаться очно в Симферополе</a>
              </div>
          </div>
      ))}
    </div>
  );
}
